import React, { useEffect, useState } from "react";
import SisLoader from "../../../../widgets/loader";
import { Button } from "antd";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import AddPurifierModal from "../components/AddPurifierModal";
import { ErrorToast, SuccessToast } from "../../../../widgets/AppToast";
import PurifierTable from "../components/PurifierRow";

function ShipPurifierDetails({ id, onSuccess }) {
  const [loader, set_loader] = useState(false);
  const [FilteredData, setFilteredData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [responeData, setResponeData] = useState({});
  const [errors, set_errors] = useState({});

  const LIST_API = () => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("ship_id", id);
    try {
      post(ApiURL.list_purifier_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setFilteredData(res?.response_data);
        }
      });
    } catch (error) {
      console.error("Error fetching ship list:", error);
    } finally {
    }
  };

  const ADD_API = (data) => {
    set_loader(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("title", data?.title);
    FORM_DATA.append("purifie_model", data?.Model);
    FORM_DATA.append("purifier_make", data?.make);
    FORM_DATA.append("selected_parameters", JSON.stringify(data?.selectedParams));
    FORM_DATA.append("other_parameters", JSON.stringify(data?.customParams));
    FORM_DATA.append("ship_id", id);
    post(ApiURL.add_purifier_details_com, FORM_DATA).then((res) => {
      if (res?.status == true) {
        SuccessToast(res?.message);
        LIST_API();
        setIsModalOpen(false);
        set_loader(false);
        if (onSuccess) onSuccess();
        } else {
          set_loader(false);
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
    });
  };

  const UPDATE_API = (data) => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("title", data?.title);
      FORM_DATA.append("purifie_model", data?.Model);
      FORM_DATA.append("purifier_make", data?.make);
      FORM_DATA.append("selected_parameters", JSON.stringify(data?.selectedParams));
      FORM_DATA.append("other_parameters", JSON.stringify(data?.customParams));
      FORM_DATA.append("request_type", "add-edit");
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("id", data?.id);

      post(ApiURL.ship_purifier_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast("Congratulation!!", "Purifier Details Successfully Update!!");
          set_loader(false);

          LIST_API();
          setIsModalOpen(false);
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
          set_loader(false);
        }
      });
    } catch (error) {
      set_loader(false);
      ErrorToast("Error Occurred", "There was an error during registration.");
    }
  };

  const VIEW_API = (data) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("id", data?.id);
      FORM_DATA.append("request_type", "view");
      post(ApiURL.ship_purifier_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setResponeData(res?.purifier_data);
          setIsModalOpen(true);
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
      });
    } catch {}
  };

  useEffect(() => {
    LIST_API();
  }, []);

  const showModal = () => {
    setIsModalOpen(true);
  };
  return (
    <>
      <div style={{ position: "relative" }}>
        <h3 style={{ marginTop: "15px", marginBottom: "15px" }}>Purifier Information </h3>
        <Button
          type="primary"
          onClick={showModal}
          style={{ position: "absolute", right: "0px", top: "-10px" }}
        >
          Add Purifier
        </Button>
        <AddPurifierModal
          visible={isModalOpen}
          onOk={(data) => {
            if (responeData?.id) {
              UPDATE_API({ ...data, id: responeData?.id });
            } else {
              ADD_API(data);
            }
          }}
          onCancel={() => {
            setIsModalOpen(false);
            setResponeData({});
            set_errors({});
          }}
          responeData={responeData}
          errors={errors}
        />

        {loader ? (
          <SisLoader />
        ) : (
          <>
            {FilteredData?.length > 0 ? (
              <PurifierTable data={FilteredData} onEdit={(row) => VIEW_API(row)} />
            ) : (
              "No data available"
            )}
          </>
        )}
      </div>
    </>
  );
}

export default ShipPurifierDetails;
